import {useIsTabletByScreen} from 'core/hooks/useIsTabletByScreen';
import {FC, ReactNode, useEffect, useState} from 'react';

interface IProps {
    children: ReactNode;
}

export const ClientDesktopOnly: FC<IProps> = ({children}) => {
    const [isShow, setIsShow] = useState(true);
    const isTablet = useIsTabletByScreen();

    useEffect(() => {
        setIsShow(!isTablet);
    }, [isTablet]);

    if (isShow) {
        return <>{children}</>;
    }

    return null;
};
